export default {
  serviceUnavailable: 'Сервис недоступен :(',
  tryAgain: 'Попробуй снова или обратись к HR-менеджеру.',
  serverUnavailable: 'Сервер недоступен',
};
